export const FinancePortalEnv = {
  Dev: 'finance-portal-dev',
  Uat: 'finance-portal-uat',
  Prod: 'finance-portal-prod',
}

export interface LoginRequest {
  envName: string
}

export interface ImpersonateUserRequest {
  envName: string
  username: string
}

export interface VerifyTokenResponse {
  valid: boolean
}

export interface LoginResponse {
  data: {
    envName: string
    accessToken: string
  }
}

export type ModuleFunction = {
  moduleName: 'assume-identity'
  functionName: 'assume-user' | & string
} | {
  moduleName: 'finance-portal'
  functionName: 'access-portal' | & string
} | {
  moduleName: 'invoice-allocation'
  functionName: 'manage-invoice-details' | 'read-invoice-details' | & string
} | {
  moduleName: 'deferred-bonus'
  functionName: 'manage-deferred-bonuses' | 'approve-deferred-bonus-requests' | & string
}

export interface AuthPayload {
  env: string
  roles: string []
  exp: number,
  aud: string,
  iss: string,
  sub: string,
}

export interface User {
  name: string
  roles: string[]
  env: string
  exp: number
  token: string
}

export interface AuthState {
  user?: User
  permissions?: ModuleFunction[]
  impersonatedUsername?: string
}
